import {ModuleFc} from '@/project'
import {User, UserState} from './types'

export {UserState}

const module: ModuleFc<UserState> = (ctx) => ({
  namespaced: true,
  state: {
    users: [],
  },
  actions: {
    /**
     * Get User lsit by biz id
     * @param commit
     * @param rootState
     * @param bizId
     */
    async getUsers({commit, rootState}, bizId) {
      const result = await ctx.$axios({
        url: '/users',
        method: 'get',
        data: {
          get bizId() {
            return bizId || rootState.biz.id
          },
        },
      })
      commit('replace', result.data.results)
    },
    /**
     * Remove user by user id
     * @param rootState
     * @param payload
     */
    async deleteUser({rootState}, payload) {
      const {bizId = rootState.biz.id, userId} = payload
      await ctx.$axios({
        url: '/users/$id',
        method: 'delete',
        params: {bizId, userId},
      })
    },
    /**
     * Send user invitation by sms
     * @param rootState
     * @param payload
     */
    async postUserInvite({rootState}, payload) {
      const {bizId = rootState.biz.id, phoneNumber} = payload
      await ctx.$axios({
        url: '/invitations',
        method: 'post',
        params: {bizId},
        data: {phoneNumber},
      })
    },
    /**
     * Send user utm info
     */
    async postUserUtm() {
      const utm_source = localStorage.getItem('utm_source')
      localStorage.removeItem('utm_source')
      const utm_medium = localStorage.getItem('utm_medium')
      localStorage.removeItem('utm_medium')
      const utm_campaign = localStorage.getItem('utm_campaign')
      localStorage.removeItem('utm_campaign')
      const ref_code = localStorage.getItem('ref_code')
      localStorage.removeItem('ref_code')
      localStorage.removeItem('match_token')
      await ctx.$axios({
        url: '/users/utm-access',
        method: 'post',
        params: {utm_source, utm_medium, utm_campaign, ref_code},
      })
    },
  },
  mutations: {
    /**
     * Remove all users and add new User list
     * @param state
     * @param payload
     */
    replace(state, payload: User[]) {
      state.users = payload
    }
  }
})

export default module
